// extracted by mini-css-extract-plugin
export default {"infoItem":"InfoItem_infoItem__AwPVE","labelInfoItem":"InfoItem_labelInfoItem__wg69Y","infoItemText":"InfoItem_infoItemText__pgoMX","green":"InfoItem_green__D323L"};